'use client'

import Loader from "@/Layout/Loader";
import CustomFetch from "@/Utils/APIRequest/AxiosInstance";
import { PrivacyPolicyAPI } from "@/Utils/APIRequest/Endpoints";
import { useTranslation } from "@/Utils/Hooks/useTranslate";
import { useQuery } from "@tanstack/react-query";

const PrivacyPolicy = () => {
  const { translations } = useTranslation();
  const { data, isPending } = useQuery({ queryKey: [PrivacyPolicyAPI], queryFn: () => CustomFetch({ url: PrivacyPolicyAPI }, null, false), refetchOnWindowFocus: false, select: (data) => data?.data?.data });

  if (isPending) return <Loader />

  return (
    <>
      <div className="">
        <h2 className="text-primary text-xl mb-9 font-medium leading-6">🔐 {translations?.privacyPolicy}</h2>
        <div className="text-sm leading-normal font-normal custom-content" dangerouslySetInnerHTML={{ __html: data?.description }}></div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
